// "You've been signed out" plumbing (Edward, 2026-11-04). When Cognito can no
// longer renew a session, requests go out with no token, the API answers 401,
// and every page quietly renders empty ("0 programs") as if it were real data.
// The API only ever returns 401 for a missing/invalid token (backend
// app/auth.py), so one 401 is enough to say the session is gone.

const listeners = new Set();
let expired = false;

export function markSessionExpired() {
  if (expired) return;
  expired = true;
  listeners.forEach(fn => fn());
}

export function isSessionExpired() { return expired; }

// Returns an unsubscribe function, for a useEffect cleanup.
export function onSessionExpired(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// Sign-in is a full-page redirect through Cognito that lands back on the site
// root, so remember where the person was and put them back there afterwards.
const RETURN_KEY = 'netra_return_to';

export function rememberReturnPath(path) {
  try { window.sessionStorage.setItem(RETURN_KEY, path); } catch (e) { /* storage blocked */ }
}

// The saved path, once — cleared on read. Only a same-site path is honoured.
export function takeReturnPath() {
  let path = null;
  try {
    path = window.sessionStorage.getItem(RETURN_KEY);
    window.sessionStorage.removeItem(RETURN_KEY);
  } catch (e) { /* storage blocked */ }
  return path && path.startsWith('/') && !path.startsWith('//') ? path : null;
}

// Test hook: the module keeps state for the app's lifetime.
export function resetSessionExpiryForTests() { expired = false; listeners.clear(); }
